import { ListItemIcon, styled, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const SelectLabel = styled(Typography)(({ theme }) => {
  return {
    color: palette.text.header,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '128%',
    margin: '0 0 8px 0',
  };
}) as typeof Typography;

export const AutocompleteOption = styled('li')<{ isSelected: any }>(({ isSelected }) => {
  return {
    width: '100%',
    color: palette.text.header,
    fontSize: '14px',
    fontWeight: isSelected ? 500 : 400,
    lineHeight: '136%',
    padding: '8px!important',
    borderRadius: '8px',
    display: 'flex!important',
    justifyContent: 'space-between!important',
    backgroundColor: 'transparent!important',

    '&.Mui-focused': {
      '&:hover': {
        backgroundColor: '#F4E8FF!important',
      },
    },

    '&:hover': {
      backgroundColor: '#F4E8FF!important',
    },
  };
});

export const Checkmark = styled(ListItemIcon)({
  minWidth: 'auto!important',
  color: '#3D1E66',

  '> svg': {
    width: '20px',
    height: '20px',
  },
});
